import { NavLinkInterface } from './sim-main-layout.model';

/**
 * Returns a copy of `links` where the links named in `names` are disabled and carry `reason`
 * as the tooltip explaining why (e.g. a feature that needs an IoT hub). Other links are returned as-is.
 */
export function disableNavLinks(
  links: readonly NavLinkInterface[],
  names: readonly string[],
  reason: string
): NavLinkInterface[] {
  return links.map((link) =>
    names.includes(link.name) ? { ...link, hasPrivilege: false, disabledTooltip: reason } : link
  );
}
